import { useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'
import { CreateRoutePlanForm } from '../components/CreateRoutePlanForm'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
  display: flex;
  flex-direction: column;
`
export const CreateRoutePlan: React.JSX.CFC = () => {
  const translations = useTranslate({
    createRoutePlan: 'route-planner.add-new-route',
  })

  return (
    <Wrapper>
      <h1 className="text-4xl font-bold">{translations.createRoutePlan}</h1>

      <CreateRoutePlanForm />
    </Wrapper>
  )
}
